import { render } from "./InspectionAfter.vue?vue&type=template&id=8d259a74"
import script from "./InspectionAfter.vue?vue&type=script&lang=js"
export * from "./InspectionAfter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__